angular.module("accordionAggiornamentoAdv.module", [])
    .component("accordionAggiornamentoAdv", {
        templateUrl: 'ng/components/accordionAggiornamentoAdv/accordionAggiornamentoAdv.view.html',
        controller: AccordionAggiornamentoAdvController,
        controllerAs: 'accordionAggiornamentoAdvCtrl'
    })

function AccordionAggiornamentoAdvController(
    $transactionFactory,
    RichiestePostVendita,
    CodiceNaturaClientela,
    MotivoRapporto,
    $RichiestePostVenditaService,
    $location,
    $modalService,
    $arcService,
    $configService,
    FileUploader,
    $rootScope,
    $timeout,
    $financialApiService,
    $simulationService,
    $uniService,
    $download

) {
    var self = this;
    var newAddedQuestAdv = {};

    self.$onInit = function () {
        self.newAdvEnabled = $configService.getAppConfig().envData.newAdvEnabled;
        self.supportModel = {
            loaderBackStep: false,
            loaderNextStep: false,
            loaderSuspend: false
        }
        var model = $transactionFactory.get();
        if (model.fromResume) {
            self.richiestePostVendita = RichiestePostVendita.build(model);
            $transactionFactory.clear();
        } else {
            model.viewIndex = model.index;
            model.id = model.idRichiesta;
            model.adv.idPratica = model.idRichiesta;
            var temp = {
                metadata: {
                    aggiornamentoAdv: {
                        persons: model.persons,
                        firmaDigitale: true,
                        firmaDigitaleEsterna: true,
                        relatedCtr: model.relatedCtr,
                        sae: model.sae,
                        responseStarQuestionario: model.adv,
                        questionarioAdv: model.adv.metadataAdv
                    }
                }
            }

            Object.assign(model, temp)
            self.richiestePostVendita = RichiestePostVendita.build(model);
            $transactionFactory.clear();
        }

        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1' || self.richiestePostVendita.readOnly) {
            self.popolateCheckListDownload();
            self.popolateCheckListUpload();
        }

        self.loadingStatus = {
            uploading: false,
        };

    }

    self.handleStructureChange = function (property, value) {
        self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.codiceNaturaClientela = CodiceNaturaClientela.build({
            description: value.codiceNaturaClientela.description,
            name: value.codiceNaturaClientela.name,
            value: value.codiceNaturaClientela.value,
        });
        self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.motivoRapporto = MotivoRapporto.build({
            description: value.motivoRapporto.description,
            name: value.motivoRapporto.name,
            value: value.motivoRapporto.value,
        });
        self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.provinciaAttivita = value.provinciaAttivita;
    }

    self.checkIndividualPersonFn = function (value) {
        self.checkIndividualPerson = value;
    }

    self.nextValidity = function () {
        var test = false;
        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
            test = !!self.validityCheckList;

        } else {

            if (self.newAdvEnabled) {
                test = self.checkEnableButtonForQst;
            } else {
                self.checkIndividualPerson &&
                    self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.codiceNaturaClientela &&
                    self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.codiceNaturaClientela.value &&
                    self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.motivoRapporto &&
                    self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.motivoRapporto.value &&
                    self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.provinciaAttivita;

            }



        }

        return test;
    }

    self.firmaChangedFn = function () {
        self.changedSignature = !self.changedSignature;
    }

    self.closeModal = function (value) {
        $modalService.closeModal(value);
    }

    self.closeArmamentiModal = function () {
        $modalService.closeModal("domandaArmamenti-modal");
    }

    self.sospendi = function () {
        addNewValueIntoModelADV();
        cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName);
        self.supportModel.loaderSuspend = true;
        $RichiestePostVenditaService
            .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
            .then(function () {
                self.supportModel.loaderSuspend = false;
                $location.path('/');
                $modalService.closeModal("suspendInstance");
            })
            .catch(function (error) {
                self.supportModel.loaderSuspend = false;
            })
    }

    self.next = function (fromModal, fromModalArmamenti) {
        
        if(self.richiestePostVendita.metadata.aggiornamentoAdv.questionarioAdv.note.noteCommon.domandaArmamenti && !fromModalArmamenti && !self.richiestePostVendita.metadata.aggiornamentoAdv.questionarioAdv.note.noteCommon.domandaArmamentiConferma) {
            $modalService.openModal("domandaArmamenti-modal");
            return;
        } else if(self.richiestePostVendita.metadata.aggiornamentoAdv.questionarioAdv.note.noteCommon.domandaArmamenti && fromModalArmamenti) {
            self.richiestePostVendita.metadata.aggiornamentoAdv.questionarioAdv.note.noteCommon.domandaArmamentiConferma = true;
            $modalService.closeModal("domandaArmamenti-modal");
        }

        self.supportModel.loaderNextStep = true;
        if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'M11') {
            if (fromModal) {
                $modalService.closeModal("validateRequest-modal");
                self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.warningForzatura = true;
                $uniService.submitQuestAdvArc(self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario)
                    .then(function (response) {
                        if (response.goToHome) {
                            $location.path('/');
                        } else if (response.success) {
                            $RichiestePostVenditaService
                                .nextStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                .then(function (response) {
                                    self.richiestePostVendita = response;

                                    if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                                        self.popolateCheckListDownload();
                                        self.popolateCheckListUpload();
                                    }
                                    self.supportModel.loaderNextStep = false;
                                }).catch(function (error) {
                                    console.log(error);
                                    self.supportModel.loaderNextStep = false;
                                });
                        } else {
                            self.submitError = !self.submitError;
                            self.supportModel.loaderNextStep = false;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.supportModel.loaderNextStep = false;
                        self.submitError = !self.submitError;
                    })

            } else {
                addNewValueIntoModelADV();
                $uniService.validateRequestAdv(self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario)
                    .then(function (response) {
                        if (response.details.showPopup) {
                            self.supportModel.loaderNextStep = false;
                            $modalService.openModal("validateRequest-modal");
                            self.responseValidateRequest = response;
                        } else {
                            $uniService.submitQuestAdvArc(self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario)
                                .then(function (response) {
                                    if (response.goToHome) {
                                        $location.path('/');
                                    } else if (response.success) {
                                        $RichiestePostVenditaService
                                            .nextStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                            .then(function (response) {
                                                self.richiestePostVendita = response;

                                                if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                                                    self.popolateCheckListDownload();
                                                    self.popolateCheckListUpload();
                                                }
                                                self.supportModel.loaderNextStep = false;
                                            }).catch(function (error) {
                                                console.log(error);
                                                self.supportModel.loaderNextStep = false;
                                            });
                                    } else {
                                        self.supportModel.loaderNextStep = false;
                                        self.submitError = !self.submitError;
                                    }
                                })
                                .catch(function (error) {
                                    console.log(error);
                                    self.supportModel.loaderNextStep = false;
                                    self.submitError = !self.submitError;
                                })

                        }

                    })
                    .catch(function (error) {
                        self.supportModel.loaderNextStep = false;
                        self.submitError = !self.submitError;
                    })
            }
        } else if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
            cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName);
            $arcService.completeAdv(self.richiestePostVendita.metadata.aggiornamentoAdv, self.richiestePostVendita.id, self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                .then(function (response) {
                    if (response.success) {
                        $location.path('/')
                    }
                    self.supportModel.loaderNextStep = false;
                })
                .catch(function (error) {
                    console.log(error);
                    self.supportModel.loaderNextStep = false;
                })
        }


    }

    self.back = function () {
        if (self.richiestePostVendita.readOnly) {
            $location.path('/')
        } else {
            self.supportModel.loaderBackStep = true;
            $RichiestePostVenditaService
                .backStepPv(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function (response) {
                    self.supportModel.loaderBackStep = false;
                    self.richiestePostVendita = response;
                }).catch(function (error) {
                    console.log(error);
                    self.supportModel.loaderBackStep = false;
                })
        }
    }


    self.generateDownloadLinkDocumentation = function (id) {
        var url =
            "/uni/downloadGenericDigital/service-infos/FINANCIAL_PD/" +
            "null/" +
            "/" +
            encodeURIComponent(id) +
            "/" +
            encodeURIComponent(self.richiestePostVendita.idWf) +
            "/"
        $download.getGenericDownload(url)
            .then(function (response) {
                console.log(response);
            })
    }

    self.check = function (el) {
        el.isSelected = !el.isSelected;
    };

    self.genericTrashCheck = function () {
        return (
            self.responseCheckPerson.uploadDoc &&
            self.responseCheckPerson.uploadDoc.uploadedFiles &&
            self.responseCheckPerson.uploadDoc.uploadedFiles.some(function (element) {
                return element.isSelected == true;
            })
        );
    }

    // inizio procedura upload file
    self.uploader = new FileUploader({
        url: "",
        headers: {
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
            "App-Name": $rootScope.portalName,
        },
    });

    self.uploadDataFunc = function (item, index) {
        var document =
            arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        if (item) {
            self.uploadData = item;
        }
        self.uploadDocumenti = document;
        self.currentCodeTypeNameIndex = index;
        self.isSplit = arguments[4] && arguments[4];
        self.singleFile = self.responseCheckPerson.uploadDoc;
    };

    self.finalUpload = function () {
        console.log("calling finalUpload");
        self.folderPath = "" + new Date().getTime();

        var url =
            $configService.getAppConfig().url +
            "/uni/upload/service-infos/";

        for (var int = 0; int < self.uploader.queue.length; int++) {
            self.uploader.queue[int].url = url;
        }

        var filesUpload = document.querySelector("#uploadInput_document").files;
        filesUpload = Object.keys(filesUpload).map(function (key) {
            return filesUpload[key];
        });
        var formData = new FormData();

        jQuery("#uploadInput_document").val("");
        filesUpload.forEach(function (file) {
            formData = new FormData();
            appendToForm(formData, "file", file);
            appendToForm(formData, "type", "FINANCIAL_PD");
            appendToForm(formData, "filename", file.name);
            appendToForm(formData, 'idPratica', self.richiestePostVendita.id);
            appendToForm(formData, "cdDoc", self.singleFile.cdDocNsil);
            appendToForm(formData, "ndgCliente", $configService.getUser().ndg);

            $financialApiService
                .uploadDocOnPv(formData)
                .then(function (response) {
                    if (response.success) {
                        $timeout(function () {
                            var tmp = {
                                filename: file.name,
                                id: response.id,
                                cdDoc: self.singleFile.cdDocNsil,
                                status: "1",
                                downloadKey: response.downloadKey
                            };

                            self.visualProgBarDoc = false;
                            self.responseCheckPerson.uploadDoc.uploadedFiles.push(tmp);
                        }, 1);
                    } else {
                        self.visualProgBarDoc = false;
                    }
                })
                .catch(function (error) {
                    checkIfFileRequestIsUploaded();
                    self.visualProgBarDoc = false;
                });
        });

    };

    self.generateDownloadLink = function (file) {
        var url =
            "/uni/downloadDocDigital/service-infos/?downloadKey=" +
            encodeURIComponent(file.downloadKey)

        $download.getGenericDownload(url)
            .then(function (response) {
                console.log(response);
            })

    };
    self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
        console.info("onWhenAddingFileFailed", item, filter, options);
    };

    self.uploader.onAfterAddingFile = function (fileItem) {
        console.log("fileItem", fileItem);
        self.progresso = 0;
        if (fileItem.file.size > 26214400) {
            $rootScope.$broadcast("addAlert", {
                text: "MAXIMUM_FILE_SIZE_EXCEEDED",
            });
            fileItem.remove();
            jQuery("#uploadInput_document").val("");
        }
        var fileName = fileItem.file.name;
        //if ( ) {
        self.uploader.queue[0].progress = 100;

        self.visualProgBarDoc = true;

        $timeout(function () {
            self.progresso = 100;
        }, 500);
    };

    self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
    };

    self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    };

    self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
    };

    self.uploader.onProgressAll = function (progress) { };

    self.uploader.onSuccessItem = function (fileItem, response, status, headers) {

    };

    self.uploader.onErrorItem = function (fileItem, response, status, headers) {
        console.info("onErrorItem", fileItem, response, status, headers);
        jQuery("#uploadInput_document").val("");

        $rootScope.$broadcast("addAlert", {
            text: "ERROR_UPLOADING_FILE",
        });

        $timeout(function () {
            self.visualProgBarDoc = false;
        }, 1);

        fileItem.remove();
        jQuery("#uploadInput_document").val("");
    };

    self.uploader.onCancelItem = function (fileItem, response, status, headers) {
        console.log(status);
    };

    self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (
            response &&
            response.uploadFileServicePojo &&
            response.uploadFileServicePojo.success
        ) {
            self.uploadOk = true;
            console.log(fileItem);

            var document = {
                fileStatus: null,
                isSelected: false,
                nameFile: response.uploadFileServicePojo.fileName,
                uuid: "",
                errorMessage: "",
                documentClass: "",
            };


            self.checkStatusOfFile();
            checkIfFileRequestIsUploaded();
        }
        self.uploader.queue = [];

        $timeout(function () {
            self.visualProgBarDoc = false;

        }, 1);
        jQuery("#uploadInput_document").val("");
    };

    self.uploader.onCompleteAll = function () {
        console.info("onCompleteAll");
        self.uploadCompleted = true;
    };

    self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
        self.uploading = false;
    };

    self.deletePrivacyDocument = function (index) {
        self.progresso = 100;

        self.visualProgBarDoc = true;

        $timeout(function () {
            self.progresso = 0;
        }, 200);

        self.documentsToBeDeleted = self.responseCheckPerson.uploadDoc.uploadedFiles.filter(function (elem) {
            return elem.isSelected == true;
        });

        self.documentsToBeDeleted.forEach(function (element) {
            $simulationService
                .deleteChecklistFileDigital(element.id)
                .then(function (response) {
                    console.log(response);
                    if (response.success) {
                        $timeout(function () {
                            self.visualProgBarDoc = false;
                            self.responseCheckPerson.uploadDoc.uploadedFiles = self.responseCheckPerson.uploadDoc.uploadedFiles.filter(function (e) {
                                return e.isSelected != true;
                            });

                        }, 1);
                    } else {
                        $rootScope.$broadcast("addAlert", {
                            text: "ERROR_TEC",
                        });
                        self.visualProgBarDoc = false;
                    }
                })
                .catch(function (error) {
                    $rootScope.$broadcast("addAlert", {
                        text: "ERROR_TEC",
                    });
                });
        });
    };

    self.popolateCheckListDownload = function () {
        self.restDownloadRunning = true;
        cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName);
        $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
            .then(function (response) {
                self.listOfDocumentDownload = response.listDocuments;
                self.visibleDownloadChecklist = response.visible;
                self.messageDownload = response.message;
                self.restDownloadRunning = false;
            })
            .catch(function (error) {
                console.error(error);
                self.restDownloadRunning = false;
            })
    }

    self.popolateCheckListUpload = function () {
        self.restUploadRunning = true;
        cleanPvModel(self.richiestePostVendita.metadata, self.richiestePostVendita.applicationName);
        $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
            .then(function (response) {
                self.listOfDocumentUpload = response.listDocuments;
                self.visibleUploadChecklist = response.visible;
                self.message = response.message;
                self.restUploadRunning = false;
            })
            .catch(function (error) {
                console.error(error);
                self.restUploadRunning = false;
            })
    }

    self.getWizardMap = function (viewIndex) {
        if (
            $rootScope.wizardMap.find(function (element) {
                return element.index == viewIndex;
            })
        ) {
            return $rootScope.wizardMap.find(function (element) {
                return element.index == viewIndex;
            }).viewName;
        }
    };

    self.backValidity = function () {
        if (self.richiestePostVendita && self.richiestePostVendita.viewIndex && self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
            return true;
        } else {
            return false;
        }
    }

    self.validityPage = function (value) {
        self.validityCheckList = value;
    }

    self.updateModel = function (responseQuestionario, enableNextButton, newAdded) {
        self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario = responseQuestionario;
        self.checkEnableButtonForQst = enableNextButton;
        newAddedQuestAdv = newAdded;
    }


    var addNewValueIntoModelADV = function () {
        if (newAddedQuestAdv.nuoviTitolari && newAddedQuestAdv.nuoviTitolari.length) {

            newAddedQuestAdv.nuoviTitolari.forEach(function (element) {
                var checkCfIsPresent = self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.titolari.titolari.some(function (titolare) {
                    return titolare.cf == element.cf
                })
                if (!checkCfIsPresent) {
                    self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.titolari.titolari.push(element)
                }
            })
        }

        if (newAddedQuestAdv.nuoviEsecutori && newAddedQuestAdv.nuoviEsecutori.length) {

            newAddedQuestAdv.nuoviEsecutori.forEach(function (element) {
                var checkCfIsPresent = self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.esecutori.esecutori.some(function (titolare) {
                    return titolare.cf == element.cf
                })
                if (!checkCfIsPresent) {
                    self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.esecutori.esecutori.push(element)
                }
            })
        }

        if (newAddedQuestAdv.nuoveFiduciarie && newAddedQuestAdv.nuoveFiduciarie.length) {
            if (!self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.fiduciarie) {
                self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.fiduciarie = {
                    fiduciarie: []
                }
            }
            self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.fiduciarie.fiduciarie = self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.fiduciarie.fiduciarie.concat(newAddedQuestAdv.nuoveFiduciarie);

            newAddedQuestAdv.nuoveFiduciarie.forEach(function (element) {
                var checkCfIsPresent = self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.fiduciarie.fiduciarie.some(function (titolare) {
                    return titolare.cf == element.cf
                })
                if (!checkCfIsPresent) {
                    self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.fiduciarie.fiduciarie.push(element)
                }
            })
        }

        if (newAddedQuestAdv.nuovoFiduciante && newAddedQuestAdv.nuovoFiduciante.length) {
            if (!self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.fiducianti) {
                self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.fiducianti = {
                    fiducianti: []
                }
            }
            newAddedQuestAdv.nuovoFiduciante.forEach(function (element) {
                var checkCfIsPresent = self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.fiducianti.fiducianti.some(function (titolare) {
                    return titolare.cf == element.cf
                })
                if (!checkCfIsPresent) {
                    self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.metadataAdv.fiducianti.fiducianti.push(element)
                }
            })
        }

    }


    self.check = function (el) {
        el.isSelected = !el.isSelected;
    };

    // inizio procedura upload file
    self.uploader = new FileUploader({
        url: "",
        headers: {
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
            "App-Name": $rootScope.portalName,
        },
    });

    self.uploadDataFunc = function (item, index) {
        var document =
            arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        if (item) {
            self.uploadData = item;
        }
        self.uploadDocumenti = document;
    };

    self.finalUpload = function () {
        self.disabledForUploadingInProgress = true;
        for (var int = 0; int < self.uploader.queue.length; int++) {
            self.uploader.queue[int].url = $configService.getAppConfig().url +
                "/uni/upload/service-infos/";
        }
        self.loadingStatus.uploading = true;
        var filesUpload = document.querySelector("#uploadInput_documentAdv").files;
        filesUpload = Object.keys(filesUpload).map(function (key) {
            return filesUpload[key];
        });
        var formData = new FormData();
        jQuery("#uploadInput_documentAdv").val("");
        filesUpload.forEach(function (file) {
            formData = new FormData();
            appendToForm(formData, "file", file);
            appendToForm(formData, "filename", file.name);
            appendToForm(formData, "idPratica", self.richiestePostVendita.metadata.aggiornamentoAdv.responseStarQuestionario.id);
            $financialApiService
                .uploadDocStatSocOnAdv(formData)
                .then(function (response) {
                    if (response.success) {
                        $timeout(function () {
                            var tmp = {
                                filename: file.name,
                                id: response.id,
                                cdDoc: self.uploadDocumenti.cdDocNsil,
                                downloadKey: response.downloadKey
                            };

                            self.visualProgBarDoc = false;
                            self.responseValidateRequest.uploadDoc.uploadedFiles.push(tmp);
                        }, 1);
                    } else {
                        self.visualProgBarDoc = false;
                    }
                })
                .catch(function (error) {
                    self.visualProgBarDoc = false;
                });

        });
    }

    self.generateDownloadLink = function (file) {
        var input = {};
        var url = "";
        if (file) {

            input = {
                downloadKey: file.downloadKey
            }
            url = "/uni/downloadDocDigital/service-infos/"

        } else {
            input = {};
            url = "/uni/download/service-infos/GUIDA_UPLOAD_ADV/";
        }

        $download.getGenericDownload(url, input)
            .then(function (response) {
                console.log(response)
            })

    };
    self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
        console.info("onWhenAddingFileFailed", item, filter, options);
    };

    self.uploader.onAfterAddingFile = function (fileItem) {
        console.log("fileItem", fileItem);
        self.disabledForUploadingInProgress = true;
        self.progresso = 0;
        if (fileItem.file.size > 26214400) {
            $rootScope.$broadcast("addAlert", {
                text: "MAXIMUM_FILE_SIZE_EXCEEDED",
            });
            fileItem.remove();
            jQuery("uploadInput_documentAdv" + self.currentCodeTypeNameIndex).val("");
        }
        var fileName = fileItem.file.name;
        //if ( ) {
        self.uploader.queue[0].progress = 100;

        self.visualProgBarDoc = true;

        $timeout(function () {
            self.progresso = 100;
        }, 500);
        /*     } else {
              fileItem.remove();
              jQuery("uploadInput_documentAdv" + self.currentCodeTypeNameIndex).val("");
              $rootScope.$broadcast("addAlert", {
                text: "FORMAT_NOT_SUPPORTED",
              });
              self.disabledForUploadingInProgress = false;
              self.uploadInProgess({
                uploadInProgess: false,
              });
            } */
    };

    self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
    };

    self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
        self.disabledForUploadingInProgress = true;
        self.uploadInProgess({
            uploadInProgess: true,
        });
    };

    self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
    };

    self.uploader.onProgressAll = function (progress) { };

    self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
        self.loadingStatus.uploading = false;
    };

    self.uploader.onErrorItem = function (fileItem, response, status, headers) {
        console.info("onErrorItem", fileItem, response, status, headers);
        self.loadingStatus.uploading = false;
        jQuery("uploadInput_documentAdv" + self.currentCodeTypeNameIndex).val("");

        $rootScope.$broadcast("addAlert", {
            text: "ERROR_UPLOADING_FILE",
        });

        self.disabledForUploadingInProgress = false;
        self.uploadInProgess({
            uploadInProgess: false,
        });
        $timeout(function () {
            self.visualProgBarDoc = false;
        }, 1);

        fileItem.remove();
        jQuery("uploadInput_documentAdv" + self.currentCodeTypeNameIndex).val("");
    };

    self.uploader.onCancelItem = function (fileItem, response, status, headers) {
        console.log(status);
    };

    self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (
            response &&
            response.uploadFileServicePojo &&
            response.uploadFileServicePojo.success
        ) {
            self.uploadOk = true;
            console.log(fileItem);

            var document = {
                fileStatus: null,
                isSelected: false,
                nameFile: response.uploadFileServicePojo.fileName,
                uuid: "",
                errorMessage: "",
                documentClass: "",
            };

            self.listOfFilesUpload = response.metadataUniUpload.uploadedfile.sort(
                function (a, b) {
                    if (a.codiceDocNSIL > b.codiceDocNSIL) {
                        return 1;
                    } else {
                        return -1;
                    }
                }
            );
        }
        self.uploader.queue = [];

        $timeout(function () {
            self.visualProgBarDoc = false;

            self.disabledForUploadingInProgress = false;
            self.uploadInProgess({
                uploadInProgess: false,
            });
        }, 1);
        jQuery("uploadInput_documentAdv" + self.currentCodeTypeNameIndex).val("");
    };

    self.uploader.onCompleteAll = function () {
        console.info("onCompleteAll");
        self.uploadCompleted = true;
    };

    self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
        self.uploading = false;
    };

    self.deletePrivacyDocument = function (index) {
        self.progresso = 100;

        self.visualProgBarDoc = true;

        $timeout(function () {
            self.progresso = 0;
        }, 200);

        self.documentsToBeDeleted = self.responseValidateRequest.uploadDoc.uploadedFiles
            .filter(function (elem) {
                return elem.isSelected == true;
            });


        self.documentsToBeDeleted.forEach(function (element) {
            var checklistType = undefined;
            $simulationService
                .deleteChecklistFileDigital(element.id, checklistType)
                .then(function (response) {
                    console.log(response);
                    if (response.success) {
                        $timeout(function () {
                            self.visualProgBarDoc = false;
                            self.responseValidateRequest.uploadDoc.uploadedFiles = self.responseValidateRequest.uploadDoc.uploadedFiles
                                .filter(function (e) {
                                    return e.isSelected != true;
                                });

                        }, 1);
                    } else {
                        self.visualProgBarDoc = false;
                    }
                })
                .catch(function (error) {
                    self.visualProgBarDoc = false;
                });
        });
    };

    self.genericTrashCheck = function () {
        return (
            self.responseValidateRequest.uploadDoc &&
            self.responseValidateRequest.uploadDoc.uploadedFiles &&
            self.responseValidateRequest.uploadDoc.uploadedFiles.some(function (element) {
                return element.isSelected == true;
            })
        );
    }

}